import { Card as CardComponent } from './Card'

export default CardComponent
// eslint-disable-next-line import/export
export * from './Card'
